import {Injectable, Component} from '@angular/core';
import {IMarketing} from '../models/Marketing';

// tslint:disable-next-line:ban-types
declare var fbq: Function;

@Injectable()
export class MarketingService {

  public onEventFacebook(event: IMarketing) {

/*
fbq('track', event.eventCategory, {
      content_name: event.eventLabel,
      content_category: event.eventCategory,
      content_ids: [],
      content_type: event.eventAction,
      value: event.eventValue,
      currency: 'ARS'
    });*/


    fbq('track', event.eventCategory);

    console.log('Reached');


  }

  public setEventData(eventCategory, eventAction, eventLabel): IMarketing {

    return {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue: 0
    };
  }

}
